module.exports = __webpack_public_path__ + "media/type5(common).db109389.mp4";